
/**
 * Metodo para obtener las maquinas asocuadas a un admin
 * @param {Integer} idAdmin 
 */
import { request } from "../../app/api-client/ApiClient";


export function getpoll(dispatch) {

	return request({
		url: `${process.env.REACT_APP_API_POLL}/v1/poll/list/all`,
		method: "GET",
	}, dispatch);
}
export function performCreateNewPoll(Request) {
	let url = `${process.env.REACT_APP_API_POLL}/v1/poll/create`;
	return request({
		url: url,
		method: "POST",
		body: JSON.stringify(Request),
	});
}
export function editPolls(Request) {
	let url = `${process.env.REACT_APP_API_POLL}/v1/poll/edit`;
	return request({
		url: url,
		method: "PUT",
		body: JSON.stringify(Request),
	});
}
export function findQuestionByIdPoll(id) {

	return request({
		url:`${process.env.REACT_APP_API_POLL}/v2/poll/listQuestionByPoll/${id}`,
		method:"GET"
	})

}
export function createNewOpenQuestionPoll(Request) {
	let url = `${process.env.REACT_APP_API_POLL}/v1/question/create`;
	return request({
		url: url,
		method: "POST",
		body: JSON.stringify(Request),
	});
}

export function editQuestionPolls(Request) {
	let url = `${process.env.REACT_APP_API_POLL}/v1/question/edit`;
	return request({
		url: url,
		method: "PUT",
		body: JSON.stringify(Request),
	});
}
export function ListResponsebyid(id) {

	return request({
		url:`${process.env.REACT_APP_API_POLL}/v1/answer/list/question/${id}`,
		method:"GET"
	})

}
export function CreateNewResponse(Request) {
	let url = `${process.env.REACT_APP_API_POLL}/v1/answer/create`;
	return request({
		url: url,
		method: "POST",
		body: JSON.stringify(Request),
	});
}
export function EditResponse(Request) {
	let url = `${process.env.REACT_APP_API_POLL}/v1/answer/edit`;
	return request({
		url: url,
		method: "PUT",
		body: JSON.stringify(Request),
	});
}


/// results
export function getResults(dispatch,id) {

	return request({
		url: `${process.env.REACT_APP_API_POLL}/v1/poll/Answersbyquestion/${id}`,
		method: "GET",
	}, dispatch);
}
export function getResultsOfUsers(dispatch,id) {

	return request({
		url: `${process.env.REACT_APP_API_POLL}/v2/poll/AnswersUserByPoll/${id}`,
		method: "GET",
	}, dispatch);
}